"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pullout = exports.PulloutContainer = exports.PulloutType = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var Icon_1 = require("../Common/Icon");
var PulloutType;
(function (PulloutType) {
    PulloutType["Error"] = "Error";
    PulloutType["Locked"] = "Locked";
    PulloutType["MissingData"] = "MissingData";
    PulloutType["Note"] = "Note";
    PulloutType["Warning"] = "Warning";
})(PulloutType = exports.PulloutType || (exports.PulloutType = {}));
exports.PulloutContainer = styled_components_1.default.div.attrs({
    className: 'tws-pullout-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 25px;\n\t", ";\n\t", ";\n\t", ";\n\tposition: relative;\n\twidth: 100%;\n\n\t.pullout-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tfont-size: 14px;\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t\tposition: absolute;\n\t\ttop: -10px;\n\t\tright: calc(0px - 10px);\n\t\tborder-radius: 16px;\n\t\tborder: 2px solid ", ";\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n"], ["\n\tpadding: 25px;\n\t", ";\n\t", ";\n\t", ";\n\tposition: relative;\n\twidth: 100%;\n\n\t.pullout-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tfont-size: 14px;\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t\tposition: absolute;\n\t\ttop: -10px;\n\t\tright: calc(0px - 10px);\n\t\tborder-radius: 16px;\n\t\tborder: 2px solid ", ";\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n"])), function (props) { return (props.color !== undefined ? "color: ".concat(props.color) : 'color: #ffffff'); }, function (props) { return (props.bgcolor !== undefined ? "background-color: ".concat(props.bgcolor) : 'background-color: #444444'); }, function (props) { return (props.fontSize !== undefined ? "font-size: ".concat(props.fontSize) : "font-size: ".concat(globalVars_module_scss_1.default.fontSizeMedium)); }, globalVars_module_scss_1.default.white, function (props) { return (props.type === PulloutType.Note ? globalVars_module_scss_1.default.secondaryGreen : globalVars_module_scss_1.default.red); }, globalVars_module_scss_1.default.white);
exports.PulloutContainer.displayName = 'PulloutContainer';
var Pullout = /** @class */ (function (_super) {
    __extends(Pullout, _super);
    function Pullout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Pullout.prototype.render = function () {
        var icon = Icon_1.IconType.tableWarning;
        switch (this.props.type) {
            case PulloutType.Error:
                icon = Icon_1.IconType.exclamation;
                break;
            case PulloutType.Locked:
                icon = Icon_1.IconType.security;
                break;
            case PulloutType.MissingData:
                icon = Icon_1.IconType.unlink;
                break;
            case PulloutType.Note:
                icon = Icon_1.IconType.file;
                break;
            case PulloutType.Warning:
                icon = Icon_1.IconType.warning;
                break;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(exports.PulloutContainer, __assign({}, this.props),
                React.createElement(Common_1.Icon, { name: icon, className: 'pullout-icon' }),
                this.props.children)));
    };
    return Pullout;
}(React.Component));
exports.Pullout = Pullout;
var templateObject_1;
